export default __webpack_public_path__ + "media/zurb/img/work/client-logo-small-de3365b7525fc5b2dafd18f91b06f9e4.jpg";